import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { DashboardDemoComponent } from './pages/dashboarddemo.component';
import { FormLayoutDemoComponent } from './pages/formlayoutdemo.component';
import { FloatLabelDemoComponent } from './pages/floatlabeldemo.component';
import { InvalidStateDemoComponent } from './pages/invalidstatedemo.component';
import { PanelsDemoComponent } from './pages/panelsdemo.component';
import { OverlaysDemoComponent } from './pages/overlaysdemo.component';
import { MediaDemoComponent } from './pages/mediademo.component';
import { MenusDemoComponent } from './pages/menusdemo.component';
import { MessagesDemoComponent } from './pages/messagesdemo.component';
import { MiscDemoComponent } from './pages/miscdemo.component';
import { EmptyDemoComponent } from './pages/emptydemo.component';
import { ChartsDemoComponent } from './pages/chartsdemo.component';
import { FileDemoComponent } from './pages/filedemo.component';
import { DocumentationComponent } from './pages/documentation.component';
import { AppNotfoundComponent } from './pages/templates/app.notfound.component';
import { AppErrorComponent } from './pages/templates/app.error.component';
import { AppAccessdeniedComponent } from './pages/templates/app.accessdenied.component';
import { AppLoginComponent } from './pages/templates/app.login.component';
import { InputDemoComponent } from './pages/inputdemo.component';
import { ButtonDemoComponent } from './pages/buttondemo.component';
import { TableDemoComponent } from './pages/tabledemo.component';
import { ListDemoComponent } from './pages/listdemo.component';
import { TreeDemoComponent } from './pages/treedemo.component';
import { DisplayComponent } from './pages/display.component';
import { ElevationComponent } from './pages/elevation.component';
import { FlexboxComponent } from './pages/flexbox.component';
import { GridComponent } from './pages/grid.component';
import { IconsComponent } from './pages/icons.component';
import { WidgetsComponent } from './pages/widgets.component';
import { SpacingComponent } from './pages/spacing.component';
import { TypographyComponent } from './pages/typography.component';
import { TextComponent } from './pages/text.component';
import { AppCrudComponent } from './pages/templates/app.crud.component';
import { AppCalendarComponent } from './pages/templates/app.calendar.component';
import { AppTimelineDemoComponent } from './pages/templates/app.timelinedemo.component';
import { AppInvoiceComponent } from './pages/templates/app.invoice.component';
import { AppHelpComponent } from './pages/templates/app.help.component';
import { DashboardAnalyticsComponent } from './pages/dashboardanalytics.component';
import { AppMainComponent } from '../app.main.component';

export const DemoRoutes = [
	{
		path: '',
		component: AppMainComponent,
		children: [
			{ path: '', component: DashboardDemoComponent },
			{ path: 'analytics', component: DashboardAnalyticsComponent },
			{ path: 'uikit/formlayout', component: FormLayoutDemoComponent },
			{ path: 'uikit/input', component: InputDemoComponent },
			{ path: 'uikit/floatlabel', component: FloatLabelDemoComponent },
			{
				path: 'uikit/invalidstate',
				component: InvalidStateDemoComponent,
			},
			{ path: 'uikit/button', component: ButtonDemoComponent },
			{ path: 'uikit/table', component: TableDemoComponent },
			{ path: 'uikit/list', component: ListDemoComponent },
			{ path: 'uikit/tree', component: TreeDemoComponent },
			{ path: 'uikit/panel', component: PanelsDemoComponent },
			{ path: 'uikit/overlay', component: OverlaysDemoComponent },
			{ path: 'uikit/menu', component: MenusDemoComponent },
			{ path: 'uikit/media', component: MediaDemoComponent },
			{ path: 'uikit/message', component: MessagesDemoComponent },
			{ path: 'uikit/misc', component: MiscDemoComponent },
			{ path: 'uikit/charts', component: ChartsDemoComponent },
			{ path: 'uikit/file', component: FileDemoComponent },
			{ path: 'utilities/display', component: DisplayComponent },
			{ path: 'utilities/elevation', component: ElevationComponent },
			{ path: 'utilities/flexbox', component: FlexboxComponent },
			{ path: 'utilities/grid', component: GridComponent },
			{ path: 'utilities/icons', component: IconsComponent },
			{ path: 'utilities/widgets', component: WidgetsComponent },
			{ path: 'utilities/spacing', component: SpacingComponent },
			{ path: 'utilities/typography', component: TypographyComponent },
			{ path: 'utilities/text', component: TextComponent },
			{ path: 'templates/crud', component: AppCrudComponent },
			{ path: 'templates/calendar', component: AppCalendarComponent },
			{ path: 'templates/timeline', component: AppTimelineDemoComponent },
			{ path: 'templates/invoice', component: AppInvoiceComponent },
			{ path: 'templates/help', component: AppHelpComponent },
			{ path: 'templates/empty', component: EmptyDemoComponent },
			{ path: 'documentation', component: DocumentationComponent },
		],
	},
	{ path: 'templates/error', component: AppErrorComponent },
	{ path: 'templates/access', component: AppAccessdeniedComponent },
	{ path: 'templates/notfound', component: AppNotfoundComponent },
	{ path: 'templates/login', component: AppLoginComponent },
];
